import { http } from '@kunlun/dependencies';

export interface LogisticsTrackItem {
  id?: string;
  deliveryOrderNo?: string;
  logisticsNo?: string;
  logisticsCompany?: string;
  logisticsStatus?: number;
  logisticsStatusName?: string;
  province?: string;
  city?: string;
  area?: string;
  address?: string;
  trackTime?: string;
  numberPlate?: string;
  driver?: string;
  courierPhone?: string;
}

export interface LogisticsTrackV2Response {
  logisticsCompany?: string;
  waybillNo?: string;
  licensePlate?: string;
  driverName?: string;
  driverPhone?: string;
  isSelfDelivery?: boolean;
  trackList?: LogisticsTrackItem[];
  consigneeFullAddress?: string;
  consigneePhone?: string;
  consigneeName?: string;
}

/**
 * 根据模型名称获取 GraphQL query 根字段名
 */
function getQueryRoot(model: string): string {
  const parts = model.split('.');
  const className = parts[parts.length - 1];
  // 首字母小写
  const root = className.charAt(0).toLowerCase() + className.slice(1);
  return root + 'Query';
}

/**
 * 查询物流轨迹V2
 */
export const queryLogisticsTrackV2 = async (
  model: string,
  moduleName: string,
  id: string | number
): Promise<LogisticsTrackV2Response | null> => {
  const queryRoot = getQueryRoot(model);

  const gql = `
    query {
      ${queryRoot} {
        queryLogisticsTrackV2(request: { id: "${id}" }) {
          logisticsCompany
          waybillNo
          licensePlate
          driverName
          driverPhone
          isSelfDelivery
          consigneeFullAddress
          consigneePhone
          consigneeName
          trackList {
            deliveryOrderNo
            logisticsNo
            logisticsCompany
            logisticsStatus
            logisticsStatusName
            province
            city
            area
            address
            trackTime
            numberPlate
            driver
            courierPhone
          }
        }
      }
    }
  `;

  try {
    const res = await http.mutate<any>(moduleName, gql);
    return res?.data?.[queryRoot]?.queryLogisticsTrackV2 || null;
  } catch (e) {
    console.error('查询物流轨迹V2失败', e);
    return null;
  }
};
